import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { RemoveIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Header = styled.div.withConfig({
  displayName: "FloatingRemoveButton__Header",
  componentId: "sc-1jiiti9-0"
})(["position:absolute;top:10px;right:-22px;z-index:10;"]);
const HoverContainer = styled.div.withConfig({
  displayName: "FloatingRemoveButton__HoverContainer",
  componentId: "sc-1jiiti9-1"
})(["position:relative;"]);
const FloatingHeader = ({
  onClick,
  title,
  tooltipPlacement = 'top left'
}) => /*#__PURE__*/_jsx(Header, {
  children: /*#__PURE__*/_jsx(Tooltip, {
    title: title,
    placement: tooltipPlacement,
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "xs",
      use: "tertiary-light",
      onClick: onClick,
      "data-test-id": "floating-remove-button",
      children: /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "0",
        children: /*#__PURE__*/_jsx(RemoveIcon, {
          color: "icon-core-subtle",
          size: "100"
        })
      })
    })
  })
});
FloatingHeader.displayName = 'FloatingHeader';

/**
 * This component can be wrapped around a component to provide a hovering remove
 * button
 */
const FloatingRemoveButton = ({
  children,
  onClick,
  title,
  tooltipPlacement
}) => {
  const [isHovered, setIsHovering] = useState(false);
  const onMouseEnter = useCallback(() => setIsHovering(true), []);
  const onMouseLeave = useCallback(() => setIsHovering(false), []);
  return /*#__PURE__*/_jsxs(HoverContainer, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-test-id": "floating-remove-button-container",
    children: [isHovered && /*#__PURE__*/_jsx(FloatingHeader, {
      onClick: onClick,
      title: title,
      tooltipPlacement: tooltipPlacement
    }), children]
  });
};
FloatingRemoveButton.displayName = 'FloatingRemoveButton';
export { FloatingRemoveButton as default, FloatingHeader as __FloatingHeader };